import React from 'react';
import PointRankingList from '../PointRankingList';
import PointRankingListSearchBox from '../PointRankingListSearchBox';

const PointRankingListWrap = (props) => {
  const { setData, pointRanking, getList, toggleModal, getExcelDownload } = props;

  return (
    <div className="point-ranking-wrap">
      {/*포인트 랭킹 검색 박스*/}
      <PointRankingListSearchBox
        setData={(data) =>
          setData({
            path: ['pointRanking', 'searchData', ...data.path],
            value: data.value,
          })
        }
        searchData={pointRanking.searchData}
        getList={getList}
      />

      {/*포인트 랭킹 리스트*/}
      <PointRankingList
        pointRankingList={pointRanking.list}
        sortOption={pointRanking.sortOption}
        pagination={pointRanking.pagination}
        getExcelDownload={getExcelDownload}
        getList={getList}
        toggleModal={toggleModal}
      />
    </div>
  );
};

export default PointRankingListWrap;
